import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = import.meta.env.VITE_SITE_URL || 'https://business-training.by';

/**
 * Унифицированный хук для управления canonical URL.
 * Гарантирует наличие ровно одного canonical на странице.
 *
 * @param path - путь страницы (напр. '/o-trenere' или '/prodazhi-i-peregovory/trening-po-prodazham')
 *              Если не передан — формируется автоматически из текущего location.pathname.
 * @param enabled - если false, canonical не устанавливается (полезно для 404)
 */
export function useCanonical(path?: string, enabled: boolean = true) {
  const location = useLocation();
  const canonicalPath = path ?? location.pathname;
  const linkRef = useRef<HTMLLinkElement | null>(null);

  useEffect(() => {
    if (!enabled) {
      if (linkRef.current) {
        linkRef.current.remove();
        linkRef.current = null;
      }
      return;
    }

    const canonicalUrl = `${BASE_URL}${canonicalPath}`;

    // Удаляем ВСЕ существующие canonical (защита от дубликатов)
    document.querySelectorAll('link[rel="canonical"]').forEach((el) => el.remove());

    // Создаём ровно один canonical
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = canonicalUrl;
    document.head.appendChild(link);
    linkRef.current = link;

    return () => {
      if (linkRef.current) {
        // Удаляем только если это всё ещё наш элемент
        if (linkRef.current.parentNode) {
          linkRef.current.remove();
        }
        linkRef.current = null;
      }
    };
  }, [canonicalPath, enabled]);
}

export { BASE_URL };